/** Indicateur de chargement accessible (`role="status"`, `aria-live="polite"`). */
import { M } from '../catalogue/messages';

export interface ProprietesChargement {
  readonly texte?: string;
}

export function Chargement({ texte }: ProprietesChargement) {
  return (
    <div className="chargement" role="status" aria-live="polite">
      <span className="tourniquet" aria-hidden="true" />
      <span>{texte ?? M.commun.chargement}</span>
    </div>
  );
}
